export default __webpack_public_path__ + "static/media/gallery_14.91d70729.jpg";